import Validator from 'validatorjs';
import React, { Component } from 'react';
import { Button, Col, Row } from 'react-bootstrap';

import DecimalAmount from '../../../../support/DecimalAmount';
import Loading from '../../../../facturotopia/loading/Loading';
import TipoComprobante from '../../support/enum/TipoComprobante';
import ComercioExteriorBaseForm from './comercio-exterior/ComercioExteriorBaseForm';
import ComercioExteriorEmisorForm from './comercio-exterior/ComercioExteriorEmisorForm';
import ComercioExteriorReceptorForm from './comercio-exterior/ComercioExteriorReceptorForm';
import ComercioExteriorMercanciasManager from './comercio-exterior/ComercioExteriorMercanciasManager';
import ComercioExteriorPropietarioManager from './comercio-exterior/ComercioExteriorPropietarioManager';
import ComercioExteriorCatalogoManager from '../../../catalogs/managers/ComercioExteriorCatalogoManager';
import ComercioExteriorDestinatarioManager from './comercio-exterior/ComercioExteriorDestinatarioManager';
import ComercioExteriorMercanciasCalculator from '../../support/comercio-exterior/ComercioExteriorMercanciasCalculator';

const steps = {
  base: false,
  emisor: false,
  receptor: false,
  destinatario: false,
  mercancias: false,
};

class ComplementoComercioExterior extends Component {
  state = {
    data: {},
    bootCatalog: false,
    isValid: false,
  };

  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      validator: new Validator({}, this.getRules()),
      steps: {
        ...steps,
      },
    };
  }

  async componentDidMount() {
    try {
      this.fillBasicInfo();

      await ComercioExteriorCatalogoManager.boot();

      this.setState({
        bootCatalog: true,
      });
    } catch (error) {
      window.ToastManager.show({
        variant: 'error',
        message: error.message || 'Error recuperando catálogo de cartaporte',
      });
    }
  }

  fillBasicInfo = () => {
    const { data = {}, input = {} } = this.props;
    const { Emisor = {}, Receptor = {} } = data;
    const completedSteps = {
      base: true,
      emisor: true,
      receptor: true,
      destinatario: true,
      mercancias: true,
    };

    const steps = !!data.Emisor ? completedSteps : this.state.steps;

    this.setState({
      ...this.state,
      data: {
        ...data,
        Emisor: {
          ...Emisor,
          Curp: Emisor.Curp || input.Emisor.curp,
        },
        Receptor: {
          ...Receptor,
          NumRegIdTrib: Receptor.NumRegIdTrib || input.Receptor.num_reg_id_trib,
        },
      },
      steps: steps,
      isValid: !!data.Emisor,
    });
  };

  getRules = (data) => {
    return {
      CertificadoOrigen: ['required', 'string'],
      Incoterm: ['required', 'string'],
      TipoCambioUSD: ['required', 'decimal:4'],
      TotalUSD: ['required', 'decimal:2'],
      'Emisor.Domicilio': ['required'],
      'Receptor.Domicilio': ['required'],
      'Mercancias.Mercancia': ['required', 'array', 'min:1'],
    };
  };

  validate = (data) => {
    const validator = new Validator(data, this.getRules(data));

    validator.check();

    this.setState({
      validator,
    });

    return validator;
  };

  get isPropiedadDeTerceros() {
    const { data } = this.state;

    if (!!data) {
      return data.MotivoTraslado === '05' ? true : false;
    }

    return false;
  }

  get isComprobanteTraslados() {
    const { input } = this.props;

    if (!!input) {
      return TipoComprobante.make(input.TipoDeComprobante).isTraslado();
    }

    return false;
  }

  handleOnIgnoreDestinatario = () => {
    let { steps } = this.state;

    this.setState({
      ...this.state,
      steps: {
        ...steps,
        destinatario: true,
      },
    });
  };

  handleOnChange = (value, event = null) => {
    const data = {
      ...this.props.data,
      ...value,
    };

    const validator = this.validate(data);
    const isValid = validator.passes();
    let { steps } = this.state;

    if (event) {
      steps = {
        ...steps,
        [event.name]: event.isValid,
      };
    }

    this.setState({
      data,
      isValid: isValid,
      steps: steps,
    });
  };

  handleOnMercanciasChange = (value) => {
    const { Mercancias = {} } = value;
    const { Mercancia = [] } = Mercancias;

    const calc = ComercioExteriorMercanciasCalculator.make(Mercancia).get();

    const newData = {
      TotalUSD: DecimalAmount.make(calc.TotalUSD).toFixed(2),
      ...value,
    };

    const event = {
      name: 'mercancias',
      isValid: Mercancia.length > 0,
    };

    this.handleOnChange(newData, event);
  };

  handleOnAdd = () => {
    const { data = {} } = this.state;

    const ComercioExterior = {
      Version: '2.0',
      ...data,
    };

    this.props.onChange({ ComercioExterior });

    this.clearState();
  };

  handleOnCancel = () => {
    this.props.onCancel('ComercioExterior');
  };

  clearState = () => {
    this.setState({});
  };

  render() {
    const { isValid, bootCatalog, data = {}, steps } = this.state;
    const { input = {} } = this.props;

    if (!bootCatalog) {
      return <Loading />;
    }

    return (
      <>
        <div className="pb-4 text-right">
          <strong className="text-black text-upper">Complemento Comercio Exterior</strong>
        </div>

        <ComercioExteriorBaseForm
          data={data}
          input={input}
          onFormDataChange={this.handleOnChange}
        />

        {steps.base && (
          <ComercioExteriorEmisorForm
            data={data}
            onChange={this.handleOnChange}
          />
        )}

        {(!!this.isPropiedadDeTerceros || !!this.isComprobanteTraslados) && (
          <ComercioExteriorPropietarioManager
            data={data}
            onChange={this.handleOnChange}
          />
        )}

        {steps.emisor && (
          <ComercioExteriorReceptorForm
            data={data}
            onChange={this.handleOnChange}
          />
        )}

        {steps.receptor && (
          <ComercioExteriorDestinatarioManager
            data={data}
            input={input}
            onChange={this.handleOnChange}
            onIgnore={this.handleOnIgnoreDestinatario}
          />
        )}

        {steps.destinatario && (
          <ComercioExteriorMercanciasManager
            data={data}
            onChange={this.handleOnMercanciasChange}
          />
        )}

        <Row className="pb-3 text-right">
          <Col>
            <Button
              variant="secondary"
              className="mr-3"
              onClick={this.handleOnCancel}
            >
              Cancelar
            </Button>

            <Button
              variant="primary"
              disabled={!isValid}
              onClick={this.handleOnAdd}
            >
              Agregar complemento
            </Button>
          </Col>
        </Row>
      </>
    );
  }
}

export default ComplementoComercioExterior;
